import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "@/assets/style/index.scss";
import "@/assets/style/variable.scss";
import ElementPlus from "element-plus";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import "element-plus/dist/index.css";
// 动画
import "animate.css";
//请求
import http from "@/request";
//指令
import directive from '@/directive'
import scaleDirective from '@/directive/scale'
//全局组件
import OssImg from "@/components/ossImg.vue";
import Loading from "@/components/loading.vue";
import store from "@/store/index";

const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

//全局变量
app.config.globalProperties.$http = http;

//指令
app.directive("responsiveScale", scaleDirective);
//全局组件
app.component("OssImg", OssImg);
app.component("Loading", Loading);

app.use(store); 
app
  .use(ElementPlus)
  .use(router)
  .mount("#app");
